<template>
  <div class="sales page page-with-table p-2">
    <page-header class="mb-2" :title="$t('Sales')">
      <template v-slot:buttons>
        <add-new-button v-permission="'change_auction'" @click="showModal">
          <font-awesome-icon :icon="'plus-circle'" class="icon"/>
          {{ $t('New Sale') }}
        </add-new-button>
      </template>
    </page-header>
    <div class="card content-wrapper p-2">
      <SalesTable v-if="loadTable" enable-frontend-export/>
    </div>
    <sale-modal/>
  </div>
</template>

<script>
  import AddNewButton from "../../core/components/common/AddNewButton";
  import {createNamespacedHelpers} from "vuex";
  import SaleModal from "./SaleModal";
  import SalesTable from "./SalesTable";
  import PageHeader from "../../core/components/page-header/PageHeader";

  const {mapActions} = createNamespacedHelpers('sales');
  const {mapState} = createNamespacedHelpers('global');
  export default {
    name: "Sales",
    components: {PageHeader, SaleModal, SalesTable, AddNewButton},
    data() {
      return {
        loadTable: true,
      }
    },
    computed: {
      ...mapState({
        enableContinuousAuction: state => state.enableContinuousAuction,
      }),
    },
    methods: {
      ...mapActions(['showModal', 'updateTableSource'])
    },
    async beforeMount() {
      if (this.enableContinuousAuction) {
        this.loadTable = false;
        await this.$router.push({name: 'not-found'});
      }

      await this.updateTableSource({source: 'sale'});
    }
  }
</script>

<style lang="scss" scoped>

</style>

